import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import logo from '../assets/images/logo.png';

const { FiMapPin, FiClock, FiMessageSquare } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img 
                src={logo} 
                alt="Jet'n'Seal logo" 
                className="h-10 w-auto" 
              />
            </div>
            <p className="text-gray-300 text-sm">
              Expert patio cleaning and pressure washing services across Malton, Norton, Pickering and surrounding areas.
            </p>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Get In Touch</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMessageSquare} className="w-4 h-4 text-blue-400" />
                <Link to="/contact-us" className="text-gray-300 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </div>
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="w-4 h-4 text-blue-400 mt-1" />
                <div className="text-gray-300">
                  <p>Malton, Norton, Pickering</p>
                  <p>& Surrounding Areas</p>
                </div>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Our Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Patio Cleaning</li>
              <li>Driveway Cleaning</li>
              <li>Pressure Washing</li>
              <li>Surface Cleaning</li>
              <li>Outdoor Cleaning</li>
              <li>Sealing Services</li>
            </ul>
          </div>

          {/* Business Hours */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Business Hours</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiClock} className="w-4 h-4 text-blue-400" />
                <div>
                  <p>Mon - Fri: 9:00 - 5:00</p>
                  <p>Sat: 9:00 - 2:00</p>
                  <p>Sun: Closed</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-wrap gap-6 text-sm">
              <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">
                Terms & Conditions
              </Link>
              <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/sitemap" className="text-gray-300 hover:text-white transition-colors">
                Sitemap
              </Link>
            </div>
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Jet'n'Seal. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;